import { Injectable } from '@angular/core'
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, } from '@angular/router'
import { Observable } from 'rxjs/Rx'

import { AuthGuard } from '@mprep/shared/lib/guards'
import { PathConfigurationService } from '@mprep/shared/data/services'

import { NavigationService } from 'app/shared/services'

@Injectable()
export class AtlasAccessGuard implements CanActivate {
  constructor(
    private _pathConfigurationService: PathConfigurationService,
    private _authGuard: AuthGuard,
    private _navigationService: NavigationService
  ) { }

  /**
   * Via the Auth Guard, redirects user to Manhattan Prep home page if they are not logged in.
   * Redirects user to the No-Syllabus page if they are logged in but have no valid syllabi access
   */
  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this._authGuard.canActivate(route, state).concatMap((authenticated) => {
      return authenticated ? this._hasPathConfiguration() : Observable.of(false)
    })
  }

  private _hasPathConfiguration(): Observable<boolean> {
    return this._pathConfigurationService.findAllModels().map((pathConfigurations) => {
      const hasPathConfiguration = pathConfigurations.length > 0

      if (!hasPathConfiguration) {
        this._navigationService.navigateToNoSyllabusPage()
      }

      return hasPathConfiguration
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/guards/atlas-access-guard/atlas-access-guard.ts